export default __webpack_public_path__ + "static/media/warehouse.2e8c3881.svg";